module.exports = __webpack_public_path__ + "static/img/系统设置@4x.3110976f.png";